import type { UseFormReturn } from 'react-hook-form';
import { FormField, Input } from '@/shared/components';
import type {
  SupportStartInput,
  SupportStartProblem,
  SupportStartValues,
} from './supportStartModel';

export function SupportStartFields({
  form,
  problem,
}: {
  form: UseFormReturn<SupportStartInput, unknown, SupportStartValues>;
  problem: SupportStartProblem | null;
}) {
  const { register, formState } = form;
  const codeError =
    formState.errors.code?.message ?? (problem?.kind === 'wrong-code' ? problem.text : undefined);
  return (
    <>
      <FormField
        label="Bestätigungscode"
        required
        error={codeError}
        hint="Sechsstelliger Code aus Ihrer Authenticator-App. Jeder Code gilt nur einmal, auch der aus der Anmeldung – notfalls den nächsten abwarten."
      >
        <Input
          autoFocus
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={9}
          className="font-mono tracking-[0.3em]"
          {...register('code')}
        />
      </FormField>
      {problem?.kind === 'message' && (
        <p role="alert" className="text-sealwax text-sm">
          {problem.text}
        </p>
      )}
    </>
  );
}
